import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink, RouterOutlet } from '@angular/router';
import { PublicHeaderLayoutComponent } from '../public-header-layout/public-header-layout.component';
import { PublicFooterLayoutComponent } from '../public-footer-layout/public-footer-layout.component';

@Component({
    selector: 'app-layout',
    standalone: true,
    imports: [CommonModule, FormsModule, RouterOutlet, PublicHeaderLayoutComponent, PublicFooterLayoutComponent],
    templateUrl: './public-layout.component.html',
    styleUrl: './public-layout.component.scss'
})
export class PublicLayoutComponent {

    mobileMenuOpen: boolean = false;

    newsletterEmail: string = '';

    toggleMobileMenu(): void {
        this.mobileMenuOpen = !this.mobileMenuOpen;
    }

    closeMobileMenu(): void {
        this.mobileMenuOpen = false;
    }

    subscribeNewsletter(): void {
        const email: string = this.newsletterEmail.trim();

        if (!email) return;

        console.log('Newsletter:', email);
    }

    scrollToTop(): void {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

}